export default {
    summer: 'Été',
    winter: 'Hiver',
};
